import { useResolve } from "@/tsyringe-hooks/useResolve";
import { observer } from "mobx-react-lite";
import { ReplayStore, TOKEN_ReplayStore } from "./utility-stores/ReplayStore";
import { Progress } from "@/components/ui/progress";

type GlobalProgressBarProps = {
    children?: React.ReactNode;
};

const GlobalProgressBar: React.FC<GlobalProgressBarProps> = observer(({ children }) => {
    const store = useResolve<ReplayStore>(TOKEN_ReplayStore);

    return (
        <>
            <div>
                {store.eventPercentage ?
                    <Progress value={store.eventPercentage} className="h-2" /> :
                    <div className='h-2' />
                }
            </div>
            {children}
            <div className='h-2' />
        </>
    );
});

export default GlobalProgressBar;